/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VerifiableIdentityAddress } from './verifiableIdentityAddress';
import { RecoveryIdentityAddress } from './recoveryIdentityAddress';
import { IdentityWithCredentials } from './identityWithCredentials';


/**
 * Create Identity Body
 */
export interface CreateIdentityBody { 
    credentials?: IdentityWithCredentials;
    /**
     * Store metadata about the user which is only accessible through admin APIs such as `GET /admin/identities/<id>`.
     */
    metadata_admin?: any | null;
    /**
     * Store metadata about the identity which the identity itself can see when calling for example the session endpoint. Do not store sensitive information (e.g. credit score) about the identity in this field.
     */
    metadata_public?: any | null;
    /**
     * RecoveryAddresses contains all the addresses that can be used to recover an identity.  Use this structure to import recovery addresses for an identity. Please keep in mind that the address needs to be represented in the Identity Schema or this field will be overwritten on the next identity update.
     */
    recovery_addresses?: Array<RecoveryIdentityAddress>;
    /**
     * SchemaID is the ID of the JSON Schema to be used for validating the identity\'s traits.
     */
    schema_id: string;
    /**
     * State is the identity\'s state. active StateActive inactive StateInactive
     */
    state?: CreateIdentityBody.StateEnum;
    /**
     * Traits represent an identity\'s traits. The identity is able to create, modify, and delete traits in a self-service manner. The input will always be validated against the JSON Schema defined in `schema_url`.
     */
    traits: object;
    /**
     * VerifiableAddresses contains all the addresses that can be verified by the user.  Use this structure to import verified addresses for an identity. Please keep in mind that the address needs to be represented in the Identity Schema or this field will be overwritten on the next identity update.
     */
    verifiable_addresses?: Array<VerifiableIdentityAddress>;
}
export namespace CreateIdentityBody {
    export type StateEnum = 'active' | 'inactive';
    export const StateEnum = {
        Active: 'active' as StateEnum,
        Inactive: 'inactive' as StateEnum
    };
}


